import { render, staticRenderFns } from "./SmtpRelayGroupForm.vue?vue&type=template&id=18d665da&scoped=true"
import script from "./SmtpRelayGroupForm.vue?vue&type=script&lang=js"
export * from "./SmtpRelayGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d665da",
  null
  
)

export default component.exports